import { render, staticRenderFns } from "./model-file.vue?vue&type=template&id=bd335d64"
import script from "./model-file.vue?vue&type=script&lang=ts"
export * from "./model-file.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports